// Bootstraps the Stimulus application and global UI behaviours.
import { Application } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

const application = Application.start()
application.debug = false
window.Stimulus = application

document.addEventListener("turbo:load", () => {
    // Turbo replaces page fragments, so tooltips are re-initialised on each load.
    document
        .querySelectorAll('[data-bs-toggle="tooltip"]')
        .forEach(el => {
            new Tooltip(el, {
                delay: { show: 0.05, hide: 0 },
                trigger: "hover focus"
            })
        })
})

export { application }
